import React from "react";
import ScrollCalendar from "src/components/features/search-form/SearchForm/elements/Calendar/ScrollCalendar";
import { TRIP_TYPE } from "src/constants";

import { DATE_FORMAT } from "src/utils/date-utils";
import PagedCalendar from "./PagedCalendar";
import dayjs from "dayjs";

export function Calendar({
  tripType,
  minDate,
  startDate,
  endDate,
  onEndDateSelected,
  onStartDateSelected,
  isSelectingEndDate,
  isSpecificDateType,
  isScroll,
  directFlightDates = [],
}) {
  const onSelectEndDateHandler = (date) => {
    console.log("calendar comp > onSelectEndDateHandler");
    onEndDateSelected(date ? date.format(DATE_FORMAT) : "");
  };

  const onSelectStartDateHandler = (date) => {
    console.log("calendar comp > onSelectStartDateHandler");
    onStartDateSelected(date ? date.format(DATE_FORMAT) : "");
  };

  const props = {
    startDate: startDate ? dayjs(startDate) : null,
    onSelectStartDate: onSelectStartDateHandler,
    directFlightDates,
  };

  if (tripType === TRIP_TYPE.roundtrip) {
    props.endDate = endDate ? dayjs(endDate) : null;
    props.isRangeCalendar = true;
    props.onSelectEndDate = onSelectEndDateHandler;
    props.isSelectingEndDate = isSelectingEndDate;
  }

  if (isScroll) {
    return (
      <div data-testid="date-selection" className="scroll-calendar">
        <ScrollCalendar {...props} />
      </div>
    );
  } else {
    return (
      <div data-testid="date-selection" className="paged-calendar">
        <PagedCalendar {...props} isSpecificDateType={isSpecificDateType} />
      </div>
    );
  }
}
